// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__+KqAu","label":"SuperRadio_label__ZyaJg","options":"SuperRadio_options__qlm1h"};